/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/*
 *
 * Action types for Verifications.
 *
 */

import { ReduxUtils } from '@spm/core';

const FETCH_ACES_VERIFICATIONS = ReduxUtils.generateFetchActionTypes(
  'ua-library',
  `VERIFICATIONS/FETCH_ACES_VERIFICATIONS`
);

const GET_ACES_VERIFICATIONS_BY_VERIFICATION_ID = ReduxUtils.generateFetchActionTypes(
  'ua-library',
  `VERIFICATIONS/GET_ACES_VERIFICATIONS_BY_VERIFICATION_ID`
);

const POST_ACES_VERIFICATIONS_LINK_FILE = ReduxUtils.generatePostActionTypes(
  'ua-library',
  `VERIFICATIONS/POST_ACES_VERIFICATIONS_LINK_FILE`
);

const DELETE_ACES_VERIFICATIONS_FILE_LINKS_BY_LINK_ID = ReduxUtils.generateActionTypes(
  'ua-library',
  `VERIFICATIONS/DELETE_ACES_VERIFICATIONS_FILE_LINKS_BY_LINK_ID`,
  'DELETE'
);

const POST_ACES_VERIFICATIONS_CREATE_CASEWORKER_TASK = ReduxUtils.generatePostActionTypes(
  'ua-library',
  `VERIFICATIONS/POST_ACES_VERIFICATIONS_CREATE_CASEWORKER_TASK`
);

const SET_DOCUMENTS_SUBMITTED = ReduxUtils.generateActionType(
  'ua-library',
  `VERIFICATIONS/SET_DOCUMENTS_SUBMITTED`,
  'SET'
);

const SET_FORM = ReduxUtils.generateActionType('ua-library', `VERIFICATIONS/SET_FORM`, 'SET');

export {
  FETCH_ACES_VERIFICATIONS,
  GET_ACES_VERIFICATIONS_BY_VERIFICATION_ID,
  POST_ACES_VERIFICATIONS_LINK_FILE,
  DELETE_ACES_VERIFICATIONS_FILE_LINKS_BY_LINK_ID,
  POST_ACES_VERIFICATIONS_CREATE_CASEWORKER_TASK,
  SET_DOCUMENTS_SUBMITTED,
  SET_FORM,
};
